window.addEventListener(`DOMContentLoaded`, () => {
  function changeColor(phrase, who) {
    let elements = document.getElementsByClassName('investments__slide');
    for (let elem of elements) {
      elem.style.backgroundColor = '#' + elem.getAttribute("data-color");
    }
  }
  setTimeout(changeColor);
});
